import {useReactFlow} from "@xyflow/react";
import {WorkflowNodeSetting} from "@/types/node";

export const useNodeUpdater = () => {
  const {setNodes} = useReactFlow();

  const updateNodeSettingParam = (
    id: string,
    paramKey: string,
    paramValue: any,
  ) => {
    setNodes(nodes =>
      nodes.map(node => {
        if (node.id !== id) return node;

        const updatedSettings = (node.data?.settings ||
          []) as WorkflowNodeSetting[];
        const newSettings = updatedSettings.map(
          (setting: WorkflowNodeSetting) => ({
            ...setting,
            params: setting.params.map(param =>
              param.key === paramKey ? {...param, value: paramValue} : param,
            ),
          }),
        );

        return {
          ...node,
          data: {
            ...node.data,
            settings: newSettings,
            isEmpty: newSettings.every(
              setting =>
                !setting.params.some(
                  param =>
                    param.value !== undefined &&
                    param.value !== "" &&
                    (!Array.isArray(param.value) || param.value.length > 0),
                ),
            ),
          },
        };
      }),
    );
  };

  return {updateNodeSettingParam};
};
